<template>
  <div id="nav-mobile" class="nav-mobile">
    <div class="nav-mobile__top ">
      <div class="row position-relative">
        <div :class="{ 'col-auto nav-mobile__top-left mb-4': title, 'col-3 nav-mobile__top-left': !title, 'nav-mobile__top-left--user': user }">
          <div v-if="profile && user" class="nav-mobile__top-left-btns-row">
            <router-link class="button button__icon nav-mobile__button nav-mobile__button--account" :to="{name: 'user'}">
              <img src="../../../images/menu/account.svg" alt="" class="nav-mobile__button-icon">
            </router-link>

            <!-- TINY BACK BUTTON -->
            <button v-if="currentRouteName === 'profile' && !modal" class="button button__icon nav-mobile__button" @click="goBack">
              <i class="demo-icon icon-back nav-mobile__button-icon"></i>
            </button>
          </div>

          <button v-else-if="modal" type="button" class="button button__icon nav-mobile__button" data-dismiss="modal">
            <i class="demo-icon icon-back nav-mobile__button-icon"></i>
          </button>

          <button v-else class="button button__icon nav-mobile__button" @click="goBack">
            <i class="demo-icon icon-back nav-mobile__button-icon"></i>
          </button>

          <div v-if="title" class="nav-mobile__title d-inline-block">
            {{ title }}
          </div>
        </div>

        <div v-if="!title" class="col-6 nav-mobile__top-center">
          <router-link v-if="user" :to="{ name: 'members' }" class="unset">
            <img @click="clearMembersStore" class="nav-panel__logo" alt="" src="../../../images/logo/logo.png" />
          </router-link>
        </div>

        <div class="col-3 nav-mobile__top-right">
          <router-link v-if="user && (rightPaymentCoinsIcon || (currentRouteName === 'profile' && !modal))" :to="{ name: 'payment-coins' }" class="nav-mobile__coins">
            {{ user.coins + user.free_coins }}
            <img src="../../../images/others/coin.svg" alt="" class="coin-icon nav-mobile__coin-icon">
          </router-link>
          <router-link v-if="rightPaymentCartIcon" :to="{ name: 'payment-coins' }" class="button button__icon nav-mobile__button nav-mobile__button--cart">
            <img src="../../../images/menu/cart.svg" alt="" class="nav-mobile__button-icon">
          </router-link>
          <router-link v-if="rightMoreSettingsIcon" :to="{name: 'more-settings'}" class="button button__icon nav-mobile__button nav-mobile__button--settings">
            <img src="../../../images/menu/settings.svg" alt="" class="nav-mobile__button-icon">
          </router-link>

        </div>
      </div>
      <hr v-if="title">
    </div>
    <BottomMobileMenu v-if="bottom"></BottomMobileMenu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BottomMobileMenu from './BottomMobileMenu';
import MobileMenuGoBack from '../../../../js/front/views/elements/MobileMenuGoBack';
import ClearMembersStore from '../../../../js/front/views/elements/ClearMembersStore';

export default {
  name: 'MobileMenu',
  components: { BottomMobileMenu },
  mixins: [MobileMenuGoBack, ClearMembersStore],
  props: {
    isMoreSettings: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    profile: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    returnUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    currentRouteName: function () {
      return this.$route.name;
    },
    rightPaymentCoinsIcon: function () {
      return this.user && (this.currentRouteName === 'match_game' || this.currentRouteName === 'chat' || this.currentRouteName === 'members');
    },
    rightPaymentCartIcon: function () {
      return !this.isMoreSettings && !this.modal && (this.currentRouteName === 'user');
    },
    rightMoreSettingsIcon: function () {
      return !this.isMoreSettings && !this.modal;
    },
  },
  methods: {},
  mounted() {

  }
};
</script>